import Form from 'shared/components/Form'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const ContainerIcon = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  border: 2px solid ${colors.blue};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 35px;
    height: 35px;

    transform: rotate(90deg);
  }
`

export const StyledForm = styled(Form)`
  padding: 0px;
`

export const ContainerContent = styled.div`
  display: flex;

  flex-direction: column;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  input {
    width: 60%;
  }
`
export const ContainerText = styled.div`
  padding: 15px;
`
